import { render } from "./Kraepelin28View.vue?vue&type=template&id=7df7f1c9"
import script from "./Kraepelin28View.vue?vue&type=script&lang=js"
export * from "./Kraepelin28View.vue?vue&type=script&lang=js"

import exportComponent from "E:\\2023-1\\sukun\\Sukun-Psikotes-FE-Peserta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__